import { API_CHAT_PREFIX, SuiteApiClient } from "@weco/suite-client";

/**
 * Chat REST client. The dev proxy rewrites `/api/chat/*` → `/api/v1.0/*` on
 * the chat backend at :8090 (see packages/vite-suite-proxy `backendApiDevProxy`).
 */
export const chatApi = new SuiteApiClient(API_CHAT_PREFIX);
